import * as Yup from 'yup';

const validationSchema = (existing: boolean) => {
  const validation = Yup.object({
    name: Yup.string().required('Required'),
    slug: Yup.string().required('Required'),
    email_required: Yup.bool().nullable(),
    email_verification: Yup.bool().nullable(),
    password: Yup.string().nullable(),
    intro_video_asset: Yup.object().nullable(),
    disable_indexing: Yup.bool().nullable(),
    allowed_emails: Yup.array().nullable(),
    blacklisted_emails: Yup.array().nullable(),
    thumbnail_url: Yup.string().nullable(),
    personalized: Yup.bool().nullable(),
    personalization_domain: Yup.string().nullable(),
  });

  return existing
    ? validation
    : validation.shape({
        expires_at: Yup.string().nullable(),
      });
};

export default validationSchema;
